export class SingleCaseAgreement{
    agreementRequired: boolean = false;
    amount: number = 0;
    method: string = '';
    filedInEmr: boolean = false;
    status: string = '';
    dateRequested?: Date;
    notes: string = '';
    agreementType: string = '';
}